// @auto-index

import icon from './icon.png'

export { default as icon } from './icon.png'

export default {
  icon
}
